const Dashboard = {
  name: 'Dashboard',
  link: '/dashboard',
  imgpath: 'assets/img/icons/aperture.svg',
  order: 1,
  label: {
    count: 2,
    classname: 'badge bg-success'
  }
};

const Clasificados = {
  name: 'Clasificados',
  link: '/clasificados',
  imgpath: 'assets/img/icons/grid.svg',
  order: 2
};

const Noticias = {
  name: 'Noticias',
  link: '/noticias',
  imgpath: 'assets/img/icons/clipboard.svg',
  order: 3
};

const Catalogos = {
  name: 'Catálogos',
  link: '/catalogos',
  // iconclass: 'ion-levels',
  imgpath: 'assets/img/icons/levels.svg',
  order: 4,
  subitems: [{
    name: 'Categorias',
    link: '/catalogos/categorias'
  }, {
    name: 'Subcategorias',
    link: '/catalogos/subcategorias'
  }, {
    name: 'Colores',
    link: '/catalogos/colores'
  }, {
    name: 'Marca vehiculos',
    link: '/catalogos/marca-vehiculos'
  }, {
    name: 'Modelos vehiculos',
    link: '/catalogos/modelos-vehiculos'
  }, {
    name: 'Tipo operación',
    link: '/catalogos/tipo-operacion'
  }/*, {
    name: 'Tarifas',
    link: '/catalogos/tarifas'
  }*/]
};

const Reportes = {
  name: 'Reportes',
  link: '/reportes',
  imgpath: 'assets/img/icons/connection-bars.svg',
  order: 5,
  subitems: [{
    name: 'Resumen movimientos',
    link: '/reportes/resumen-movimientos'
  }, {
    name: 'Detalle movimientos',
    link: '/reportes/detalle-movimientos'
  }]
};

export const menu = [
Dashboard,
Clasificados,
Noticias,
Catalogos,
Reportes
];



// WEBPACK FOOTER //
// ./src/app/routes/menu.ts